import gql from "graphql-tag";

export const reportBatchInfo = gql`
  query ReportBatchInfo($batchId: ID!) {
    reportBatchInfo(batchId: $batchId)
  }
`;

